var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.05469 8.08334V18.0583C9.05469 18.875 9.43802 19.65 10.0964 20.1417L14.438 23.3917C15.363 24.0833 16.638 24.0833 17.563 23.3917L21.9047 20.1417C22.563 19.65 22.9463 18.875 22.9463 18.0583V8.08334H9.05469Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3307 8.70834H7.66406C7.3224 8.70834 7.03906 8.42501 7.03906 8.08334C7.03906 7.74168 7.3224 7.45834 7.66406 7.45834H24.3307C24.6724 7.45834 24.9557 7.74168 24.9557 8.08334C24.9557 8.42501 24.6724 8.70834 24.3307 8.70834Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3307 13.2917H12.6641C12.3224 13.2917 12.0391 13.0083 12.0391 12.6667C12.0391 12.325 12.3224 12.0417 12.6641 12.0417H19.3307C19.6724 12.0417 19.9557 12.325 19.9557 12.6667C19.9557 13.0083 19.6724 13.2917 19.3307 13.2917Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3307 17.4583H12.6641C12.3224 17.4583 12.0391 17.175 12.0391 16.8333C12.0391 16.4917 12.3224 16.2083 12.6641 16.2083H19.3307C19.6724 16.2083 19.9557 16.4917 19.9557 16.8333C19.9557 17.175 19.6724 17.4583 19.3307 17.4583Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoring);
export default __webpack_public_path__ + "static/media/factoring.0849bd0e5fb1f1b110a79684dd054f4c.svg";
export { ForwardRef as ReactComponent };